import $api from "../../../http";
import { MyConsumption } from "../types";

/**
 * `Ф2` (кабинет ПЗС): расход по своим местам и его выгрузка.
 *
 * Оба запроса принимают **одни и те же** параметры (`place_id`, `from`, `to`,
 * `step`): файл не может разойтись с экраном.
 */

export type ConsumptionParams = {
  place_id?: number;
  from: string;
  to: string;
  step: "day" | "month";
};

export default class CabinetConsumptionApi {
  static async getConsumption(
    params: ConsumptionParams,
  ): Promise<MyConsumption> {
    const response = await $api.get<MyConsumption>("/my/consumption", {
      params,
      withCredentials: true,
    });

    return response.data;
  }

  static async getCsv(params: ConsumptionParams): Promise<Blob> {
    const response = await $api.get("/my/consumption.csv", {
      params,
      withCredentials: true,
      responseType: "blob",
    });

    return response.data;
  }
}
